module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myNav"
    }
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarTogglerDemo01"
    }
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "nav-a"
  }, [_vm._v("ICJIA | GATA INFORMATION")])]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav mr-auto mt-2 mt-lg-0",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "javascript:void(null)",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n          About\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/overview"
    }
  }, [_vm._v("General Overview")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/news",
      "exact": ""
    }
  }, [_vm._v("News & Announcements")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("ICJIA Home")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "javascript:void(null)",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n          Grant Opportunities\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('h6', {
    staticClass: "dropdown-header"
  }, [_vm._v("Current Grant Opportunities")]), _vm._v(" "), (_vm.grants.length > 0) ? _c('div', _vm._l((_vm.grants), function(grant) {
    return _c('span', [_c('router-link', {
      staticClass: "dropdown-item",
      attrs: {
        "tag": "a",
        "to": grant.path,
        "exact": ""
      }
    }, [_vm._v(_vm._s(_vm._f("truncateMiddle")(grant.title)))])], 1)
  })) : _c('div', [_c('h6', {
    staticClass: "dropdown-header",
    staticStyle: {
      "color": "#bbb"
    }
  }, [_vm._v("There are no current grant opportunities")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('h6', {
    staticClass: "dropdown-header"
  }, [_vm._v("Archived Grant Opportunities")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/grants",
      "exact": ""
    }
  }, [_vm._v("View archive")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "tag": "a",
      "to": "/documents"
    }
  }, [_vm._v("Documents")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "javascript:void(null)",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n          Training\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/webinars"
    }
  }, [_vm._v("Webinars")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/faqs"
    }
  }, [_vm._v("FAQs")])], 1)])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse bg-about-icjia",
    attrs: {
      "id": "navbarHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 py-4"
  }, [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v("About the ICJIA")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Created in 1983, the "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us",
      "target": "_blank"
    }
  }, [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" is a state agency dedicated to improving the administration of criminal justice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The Authority brings together key leaders from the justice system and the public to identify critical issues facing the criminal justice system in Illinois, and to propose and evaluate policies, programs, and legislation that address those issues. The agency also works to ensure the criminal justice system in Illinois is efficient and effective. The Authority’s specific powers and duties are detailed in the "), _c('a', {
    attrs: {
      "href": "http://www.ilga.gov/legislation/ilcs/ilcs3.asp?ActID=397&ChapterID=5",
      "target": "_blank"
    }
  }, [_vm._v("Illinois Criminal Justice Information Act.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-4"
  }, [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("Visit website")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://twitter.com/icjia_illinois?lang=en"
    }
  }, [_vm._v("Follow on Twitter")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://www.facebook.com/ICJIA/"
    }
  }, [_vm._v("Like on Facebook")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://www.youtube.com/channel/UCtZMzk8D3P4OixYTwsfPeKA"
    }
  }, [_vm._v("View on YouTube")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://visitor.r20.constantcontact.com/manage/optin?v=001MqUcqqvjwLCJXlLMSWbTe3zHHmEQgFeBuHvBcJWTbwgrxFbDSGx4HSUPpI6DJWMUPgbljtLxffqIcGFTgCnr-auak88ybvRxpoJlTMGPtZs%3D"
    }
  }, [_vm._v("Join mailing list")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "mailto: cja.irc@illinois.gov"
    }
  }, [_vm._v("Send email")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarTogglerDemo01",
      "aria-controls": "navbarTogglerDemo01",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f672dae2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 401
// module chunks = 0